<template>
  <div class="total-wrapper">
    <span class="total-title">Total</span>
    <span class="total-price">{{ this.total | toCurrency }}</span>
  </div>
</template>

<script>
import toCurrency from '../filters/toCurrency'

export default {
  name: 'CartTotal',
  props: {
    total: {
      type: [String, Number],
    },
  },
  filters: {
    toCurrency,
  },
}
</script>

<style lang="scss" scoped>
.total-wrapper {
  font-size: 1.8rem;
  font-weight: 700;
  color: $royal !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.total-title {
  text-transform: uppercase;
}
</style>
